export class FindingEntry {
    'detectorType';
    'evidenceType';
    'evidenceDisplayName';
    'path';
    'objectType';
    'justification';
    'score';
    'anomalyGraph';
    'snapshotId';
    'conclusion';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "detectorType",
            "baseName": "detectorType",
            "type": "DetectorType",
            "format": ""
        },
        {
            "name": "evidenceType",
            "baseName": "evidenceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "evidenceDisplayName",
            "baseName": "evidenceDisplayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "objectType",
            "baseName": "objectType",
            "type": "FindingEntryObjectTypeEnum",
            "format": ""
        },
        {
            "name": "justification",
            "baseName": "justification",
            "type": "string",
            "format": ""
        },
        {
            "name": "score",
            "baseName": "score",
            "type": "number",
            "format": "float"
        },
        {
            "name": "anomalyGraph",
            "baseName": "anomalyGraph",
            "type": "AnomalyGraphData",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "conclusion",
            "baseName": "conclusion",
            "type": "SecurityScanConclusion",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FindingEntry.attributeTypeMap;
    }
    constructor() {
    }
}
export var FindingEntryObjectTypeEnum;
(function (FindingEntryObjectTypeEnum) {
    FindingEntryObjectTypeEnum["File"] = "FILE";
    FindingEntryObjectTypeEnum["Directory"] = "DIRECTORY";
    FindingEntryObjectTypeEnum["Database"] = "DATABASE";
    FindingEntryObjectTypeEnum["Schema"] = "SCHEMA";
    FindingEntryObjectTypeEnum["Table"] = "TABLE";
    FindingEntryObjectTypeEnum["Column"] = "COLUMN";
    FindingEntryObjectTypeEnum["Row"] = "ROW";
})(FindingEntryObjectTypeEnum || (FindingEntryObjectTypeEnum = {}));
